<template>
  <div class="app">
    
    <AppCards />
<!--Testimonios-->
    <v-container class="my-16">
      <v-img class="mb-6"  src="../assets/img/app/bg-app.jpg"></v-img>
      <h2 class="text-center">¿Por qué escoger Kefuri?</h2>
      <hr class="hr-k my-8">
      <v-carousel
        cycle
        height="auto"
        hide-delimiter-background
        show-arrows-on-hover
        class="my-8"
        interval="11000"
      >
        <v-carousel-item
          v-for="(slide, i) in slides"
          :key="i"
          class="px-8"
        >
          <v-row>
          <v-col cols="12">
            <p class="blue-grey--text">
              <span class="profile-quote">"</span> <br>
              {{slide.testimonio}}
              <br><span class="float-right profile-quote mr-8">"</span>
              </p>
              <br>
            <p class="blue-grey--text"> {{slide.persona}} <br>
            <small class="blue-grey--text"> {{slide.profesion}} </small>
            </p>
            
          </v-col>
        </v-row>
        </v-carousel-item>
      </v-carousel>
    </v-container>
    <!--/Testimonios-->

    <div class="bg-app-contact mt-8">
      <v-container>
        <div class="white--text my-16 text-center">
          <v-col md="8" offset-md="2">
            <h2>¿Quieres ser parte de Kefuri?</h2>
            <hr class="hr-w my-8">
            <p>
            ¿Crees que tu Hospital, Clínica o Servicio de Salud puede beneficiarse de tener más posibles donantes y donantes efectivos? Kefuri es la solución para ti. <br> Comunícate con nosotros y te responderemos a la brevedad!
            </p>
            <v-btn
              class="mt-16"
              outlined
              color="white"
              href="/#content"
              
            >
              Contáctanos
            </v-btn>
          </v-col>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
import AppCards from '../components/AppCards';

export default {
  name: 'AppKefuri',
  components: {
    AppCards
  },
  data: () => ({
    model: 0,
    slides: [
      { testimonio: 'Es una tecnología muy amigable muy fácil de utilizar que te orienta respecto a los criterios, la manera de notificar y te da fácil acceso a las personas que están a cargo de los procesos de procuramiento, siempre nos llamará la atención una tecnología así que estar marcando un número.',
        persona: 'Unidad de urgencias',
        profesion: 'Enfermera Hospital del Salvador'},

        { testimonio: 'Considero que comenzó justo cuando el ministerio le dio más importancia a los indicadores de los posibles donantes y kefuri llegó en el momento justo junto con las capacitaciones que hacían individualmente a cada medio y enfermeras, como que estimuló aún más a darle importancia a un posible donante',
        persona: 'Unidad de procuramiento',
        profesion: 'Enfermera Hospital del Salvador'},

        { testimonio: 'He avisado por medio de la aplicación y me ha parecido expedita, rápida; e increiblemente llaman muy rápido de vuelta y es algo constante. Ha mejorado mucho nuestra experiencia.',
        persona: 'Unidad de urgencias',
        profesion: 'Enfermero Hospital del Salvador'},

        { testimonio: 'La aplicación me ha parecido sencilla, rápida y en términos de notificación una muy buena interrelación con el equipo de procura, ya he alertado como 3 o 4 veces de posibles donantes.',
        persona: 'UCI',
        profesion: 'Médico Hospital del Salvador'},
    ],
  }),
  }
</script>

<style scoped lang="sass">
  
  .bg-app-contact
    background-image: url('../assets/img/bg-appccyan.jpg')
    background-size: cover
    background-position: center

  .profile-op
    overflow: hidden
    border-radius: 50%
  .profile-quote
    color: $tertiary-text
    font-size: 2.5em
    font-family: $font-kauchan
  
</style>